import { getDocs, query, where } from "firebase/firestore";
import { collection } from "firebase/firestore";
import { Query } from "firebase/firestore";
import { CollectionReference } from "firebase/firestore";
import db from "../types/firebase";
import { ApplicationStats } from "../types/stats";

export const loadApplicationStats = async (
  sponsorId: string,
  agentId: string,
  seasonId: string
) => {
  let statsRef: Query | CollectionReference;

  if (sponsorId !== "") {
    statsRef = query(collection(db, "applicationStats"), where("sponsorId", "==", sponsorId));
  } else {
    statsRef = collection(db, "applicationStats");
  }

  if (agentId !== "" && agentId !== "all_agents") {
    statsRef = query(statsRef, where("agentId", "==", agentId));
  }

  if (seasonId !== "") {
    statsRef = query(statsRef, where("seasonId", "==", seasonId));
  }

  const statsSnapshot = await getDocs(statsRef);
  const statsDict: Record<string, ApplicationStats> = {};
  statsSnapshot.forEach((doc) => {
    const data = doc.data();
    // Exclude the timestamp field from the data
    const { timestamp, ...statsData } = data;
    const stats = statsData as ApplicationStats;
    statsDict[doc.id] = stats;
  });

  return statsDict;
};
